import api from "./../utils/api";

export const getSettings = async () => {
    try {
        const response = await api.get(
            `/settings/config`,
            {
                withCredentials: true,
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateSettings = async (settings) => {
    try {
        const response = await api.put(
            `/settings/update`,
            {
                settings
            },
            {
                withCredentials: true,
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateTermOfService = async (term_of_service) => {
    try {
        const response = await api.put(
            `/settings/update/term`,
            {
                term_of_service
            },
            {
                withCredentials: true,
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updatePrivacyPolicy = async (privacy_policy) => {
    try {
        const response = await api.put(
            `/settings/update/privacy`,
            {
                privacy_policy
            },
            {
                withCredentials: true,
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};